import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { useActions } from '../../../hooks/useActions';
import { ExtendProductSubscriptionPageParamsType } from '../../../models/types/RoutePath';
import { clearCurrentOrganization } from '../../../store/redux-slices/organizations';
import { organizationNameSelector } from '../../../store/redux-slices/organizations/selectors';
import { clearSubscriptionExtensionSummary } from '../../../store/redux-slices/subscriptions/common';
import { clearDOCSubscriptionOverview } from '../../../store/redux-slices/subscriptions/dutyOfCare';
import { loadOrganization } from '../../../store/saga-slices/organizations';
import { loadDOCSubscriptionOverview } from '../../../store/saga-slices/subscriptions/dutyOfCare';
import { ILoadDOCSubscriptionOverviewPayload } from '../../../store/saga-slices/subscriptions/dutyOfCare/models';

export const useExtendDOCSubscriptionPage = () => {
  const { organizationId, subscriptionId } =
    useParams<ExtendProductSubscriptionPageParamsType>();

  const organizationName = useSelector(organizationNameSelector);

  const LoadOrganization = useActions(loadOrganization);
  const LoadSubscriptionOverview = useActions(loadDOCSubscriptionOverview);
  const ClearCurrentOrganization = useActions(clearCurrentOrganization);
  const ClearCurrentSubscription = useActions(clearDOCSubscriptionOverview);
  const ClearSubscriptionExtensionSummary = useActions(
    clearSubscriptionExtensionSummary,
  );

  useEffect(() => {
    LoadOrganization(organizationId);
    const loadSubscriptionOverviewPayload: ILoadDOCSubscriptionOverviewPayload =
      {
        organizationId,
        subscriptionId,
      };
    LoadSubscriptionOverview(loadSubscriptionOverviewPayload);
  }, [
    LoadOrganization,
    LoadSubscriptionOverview,
    organizationId,
    subscriptionId,
  ]);

  useEffect(
    () => () => {
      ClearCurrentOrganization();
      ClearCurrentSubscription();
      ClearSubscriptionExtensionSummary();
    },
    [
      ClearCurrentOrganization,
      ClearCurrentSubscription,
      ClearSubscriptionExtensionSummary,
    ],
  );

  return { organizationName, organizationId, subscriptionId };
};
